import * as React from 'react';
import { NumberField } from '@heroui/react';
import type { NumberQuestion } from '../types';

export interface NumberControlProps {
  question: NumberQuestion;
  disabled?: boolean;
  showCorrectAnswer?: boolean;
  showScore?: boolean;
  onUpdate: (updates: Partial<NumberQuestion>) => void;
}

export function NumberControl({ question, disabled, showCorrectAnswer, showScore, onUpdate }: NumberControlProps) {
  const step = question.step ?? 1;
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="space-y-2">
          <div className="text-sm font-medium text-foreground">最小值</div>
          <NumberField
            value={question.min ?? 0}
            onChange={(v) => onUpdate({ min: Number.isFinite(v) ? v : undefined })}
            isDisabled={disabled}
          >
            <NumberField.Group>
              <NumberField.DecrementButton />
              <NumberField.Input />
              <NumberField.IncrementButton />
            </NumberField.Group>
          </NumberField>
        </div>
        <div className="space-y-2">
          <div className="text-sm font-medium text-foreground">最大值</div>
          <NumberField
            value={question.max ?? 0}
            onChange={(v) => onUpdate({ max: Number.isFinite(v) ? v : undefined })}
            isDisabled={disabled}
          >
            <NumberField.Group>
              <NumberField.DecrementButton />
              <NumberField.Input />
              <NumberField.IncrementButton />
            </NumberField.Group>
          </NumberField>
        </div>
      </div>
      <div className="space-y-2">
        <div className="text-sm font-medium text-foreground">步长</div>
        <NumberField
          value={step}
          onChange={(v) => onUpdate({ step: Number.isFinite(v) && v > 0 ? v : 1 })}
          minValue={0.01}
          step={0.01}
          isDisabled={disabled}
        >
          <NumberField.Group>
            <NumberField.DecrementButton />
            <NumberField.Input />
            <NumberField.IncrementButton />
          </NumberField.Group>
        </NumberField>
      </div>
      {showCorrectAnswer ? (
        <div className="space-y-2">
          <div className="text-sm font-medium text-foreground">正确答案</div>
          <NumberField
            value={typeof question.correctAnswer === 'number' ? question.correctAnswer : 0}
            onChange={(v) => onUpdate({ correctAnswer: Number.isFinite(v) ? v : undefined })}
            minValue={question.min}
            maxValue={question.max}
            step={step}
            isDisabled={disabled}
          >
            <NumberField.Group>
              <NumberField.DecrementButton />
              <NumberField.Input />
              <NumberField.IncrementButton />
            </NumberField.Group>
          </NumberField>
        </div>
      ) : null}
      {showScore ? (
        <div className="space-y-2">
          <div className="text-sm font-medium text-foreground">分值</div>
          <NumberField
            className="w-40"
            value={question.score ?? 0}
            onChange={(v) => onUpdate({ score: Number.isFinite(v) ? v : 0 })}
            minValue={0}
            step={0.5}
            isDisabled={disabled}
          >
            <NumberField.Group>
              <NumberField.DecrementButton />
              <NumberField.Input />
              <NumberField.IncrementButton />
            </NumberField.Group>
          </NumberField>
        </div>
      ) : null}
    </div>
  );
}
